import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";

export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  return `https://www.belleproperty.com/listings?propertyType=residential&searchStatus=sold&state=${suburb.state}&suburb=${encodeURIComponent(suburb.locality)}`;
}
